import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useFidCardFunnelTracking } from '../../../../../posthog/funnelTrackingFidCard';

const DateStep = ({ value, onChange, error }) => {
  const [focused, setFocused] = useState(null);

  const { trackPageViewCreateBirthdate } = useFidCardFunnelTracking();

  useEffect(() => {
    trackPageViewCreateBirthdate({});
  }, []);

  const handleInputChange = (field, inputValue) => {
    let newValue = inputValue.replace(/\D/g, '');

    switch (field) {
      case 'day':
        if (newValue && Number.parseInt(newValue, 10) > 31) {
          return;
        }
        if (newValue.length === 1 && Number.parseInt(newValue, 10) > 3) {
          newValue = `0${newValue}`;
        }
        break;

      case 'month':
        if (newValue && Number.parseInt(newValue, 10) > 12) {
          return;
        }
        if (newValue.length === 1 && Number.parseInt(newValue, 10) > 1) {
          newValue = `0${newValue}`;
        }
        break;

      case 'year':
        if (newValue.length > 4) return;
        break;

      default:
        break;
    }

    if ((field === 'day' && newValue.length === 2) ||
      (field === 'month' && newValue.length === 2)) {
      const nextField = field === 'day' ? 'month' : 'year';
      setFocused(nextField);
    }

    onChange({ ...value, [field]: newValue });
  };

  const handleKeyDown = (field, event) => {
    if (event.key === 'Backspace' && value[field] === '') {
      const previousField = field === 'year' ? 'month' : field === 'month' ? 'day' : null;
      if (previousField) {
        setFocused(previousField);
      }
    }
  };

  const getInputClasses = (fieldName) => {
    const baseClasses = 'w-28 p-2 h-24 rounded-2xl border bg-white text-center geomanistMedium text-2xl transition-all';

    if (error) {
      return `${baseClasses} border-red-500 shadow-[0px_6px_0px_0px_#FEE2E2]`;
    }

    if (focused === fieldName) {
      return `${baseClasses} border-[#596802] bg-[#ECED90] shadow-[0px_6px_0px_0px_#596802]`;
    }

    return `${baseClasses} border-gray-200 shadow-[0px_6px_0px_0px_#e2e2e2]`;
  };

  return (
    <div className="flex flex-col gap-4 items-center">
      <div className="flex gap-2 w-full justify-center relative">
        <div className="flex flex-col items-center appear delay-100">
          <input
            type="text"
            placeholder="JJ"
            maxLength="2"
            value={value.day}
            onChange={(e) => handleInputChange('day', e.target.value)}
            onKeyDown={(e) => handleKeyDown('day', e)}
            onFocus={() => setFocused('day')}
            ref={el => focused === 'day' && el?.focus()}
            className={getInputClasses('day')}
          />
          <span className="text-xl geomanistMedium text-gray-500 mt-8">Jour</span>
        </div>

        <div className="flex flex-col items-center appear delay-200">
          <input
            type="text"
            placeholder="MM"
            maxLength="2"
            value={value.month}
            onChange={(e) => handleInputChange('month', e.target.value)}
            onKeyDown={(e) => handleKeyDown('month', e)}
            onFocus={() => setFocused('month')}
            ref={el => focused === 'month' && el?.focus()}
            className={getInputClasses('month')}
          />
          <span className="text-xl geomanistMedium text-gray-500 mt-8">Mois</span>
        </div>

        <div className="flex flex-col items-center appear delay-300">
          <input
            type="text"
            placeholder="AAAA"
            maxLength="4"
            value={value.year}
            onChange={(e) => handleInputChange('year', e.target.value)}
            onKeyDown={(e) => handleKeyDown('year', e)}
            onFocus={() => setFocused('year')}
            ref={el => focused === 'year' && el?.focus()}
            className={getInputClasses('year')}
          />
          <span className="text-xl geomanistMedium text-gray-500 mt-8">Année</span>
        </div>
      </div>

      {error && (
        <div
          className="flex items-center gap-2 px-3 py-2 bg-[#FEF2F2] rounded-lg border border-red-200 mt-4 w-full max-w-md">
          <svg className="w-4 h-4 text-red-600 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <title>Erreur</title>
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-red-700 text-sm geomanistMedium">{error}</span>
        </div>
      )}
    </div>
  );
};

export default DateStep;
